import React, { useState, useEffect } from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import Api from '../../../api/global.service';
import mapChartData from '../../../utils/mapChartData.js';
import renderCustomizedLabel from '../../../utils/renderCustomizedLabel.js';
import BlockUi from 'react-block-ui';

import useEtiquetas from '../../../hooks/useEtiquetas';
import transformWord from '../../../utils/transformWord';



const ParcelasResumenPlantas = ({ id_ciclo }) => {
  const [dataGrafica, setDataGrafica] = useState([]);
  const [blocking, setBlocking] = useState(true);
  const { etiquetas } = useEtiquetas();

  useEffect(() => {
    if (id_ciclo > 0) {
      getData();
    }
  }, [id_ciclo]);

  const getData = () => {
    setBlocking(true);
    Api.search('dashboards/parcelas/plantas', {
      filter: [{ column: 'id_ciclo', operator: '=', value: id_ciclo }],
    }).then(response => {
      let chartData = mapChartData(response.data, 'tipo', 'total');
      // console.log(chartData);
      setDataGrafica(chartData);
      setBlocking(false);
      // Set initial value
      // eslint-disable-next-line eqeqeq
    });
  };

  return (
    <BlockUi tag="div" message="" blocking={blocking} renderChildren={true} style={{ height: '95%' }}>
      <div className="row p-10 mt-2" style={{ backgroundColor: '#F3EFEC', margin: 10, borderRadius: 10, height: '100%' }}>
        <p className="dashboard-titulo-grafica">{transformWord(etiquetas?.planta, ['plural','capitalize'])} en {transformWord(etiquetas?.parcela, ['plural','lowercase'])}:</p>
        <div className="col-xl-12 col-md-12">
          <ResponsiveContainer width="100%" height={250}>
            <PieChart width={500} height={false}>
              <Pie
                data={dataGrafica}
                labelLine={false}
                label={renderCustomizedLabel}
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
                isAnimationActive={false}>
                {dataGrafica.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
          <div className="d-flex flex-wrap justify-content-center" style={{ gap: 12 }}>
            {dataGrafica.map((entry, index) => (
              <div key={index} className="d-flex align-items-center" style={{ gap: 6, maxWidth: '100%' }}>
                <span
                  style={{
                    width: 10,
                    height: 10,
                    minWidth: 10,
                    borderRadius: '50%',
                    backgroundColor: entry.color,
                    display: 'inline-block',
                  }}
                />
                <span style={{ fontSize: 12 }}>{entry.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </BlockUi>
  );
};

export default ParcelasResumenPlantas;
